// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/list-ordered.js';

import { paths } from '../generated/list-ordered';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('list-ordered', Original, paths);
